import './App.css';
import Routing from './Routing'
import Loading from './customComponents/Loading';
import LoaderHelper from './customComponents/Loading/LoaderHelper';
import { ProfileProvider } from './context/ProfileProvider';
import { ToastContainer } from 'react-toastify';
import SocketContextProvider from './customComponents/SocketContext';
import { GoogleOAuthProvider } from '@react-oauth/google';
function App() {
  return (

    <GoogleOAuthProvider clientId="43381594262-6r9a6a0ndeo7tmd4d2qhf4scm7gsnosb.apps.googleusercontent.com">

      <ProfileProvider>
        <SocketContextProvider>
          <Routing />
          <Loading ref={ref => LoaderHelper.setLoader(ref)} />
        </SocketContextProvider>
        <ToastContainer />
      </ProfileProvider>

    </GoogleOAuthProvider>


  )
};

export default App;